import fetchApi from 'services/api/connector';

export const login = (data) => fetchApi('login', { method: 'POST', data, version: 'v1' });
export const logout = (data) => fetchApi('logout', { method: 'POST', data, version: 'v1' });
export const twoFaConfirm = (data) => fetchApi('confirmation', { method: 'POST', data, version: 'v1' });
